import React from "react";
import { Body } from "../Common/Typography";
import {
  BorderWrapper,
  CommentMarkdown,
  CommentWrapper,
} from "./__styles__/Comment";

export interface CommentProps {
  content: string;
  truncate: boolean;
}

const Comment = ({ content, truncate }: CommentProps) => {
  return (
    <CommentWrapper>
      <BorderWrapper truncate={truncate}>
        <Body size="default" type="regular" as="div">
          <CommentMarkdown
            markdown={content}
            truncate={truncate}
            options={{ simpleLineBreaks: true }}
          />
        </Body>
      </BorderWrapper>
    </CommentWrapper>
  );
};

export default Comment;
